export const ComponentTypeEnums = {
  // 文本
  TEXT: 'text',
  // 图片
  IMG: 'img',
  // 视频
  VIDEO: 'video',
  // 附件
  ATTACHMENT: 'attachment',
  // 流程
  FLOW: 'flow',
  // 轮播
  CAROUSEL: 'carousel'
}

export const ComponentTypeList = [
  {
    key: ComponentTypeEnums.TEXT,
    componentName: 'PText'
  },
  {
    key: ComponentTypeEnums.IMG,
    componentName: 'PImage'
  },
  {
    key: ComponentTypeEnums.VIDEO,
    componentName: 'PVideo'
  },
  {
    key: ComponentTypeEnums.ATTACHMENT,
    componentName: 'PAttachment'
  },
  {
    key: ComponentTypeEnums.FLOW,
    componentName: 'PFlow'
  },
  {
    key: ComponentTypeEnums.CAROUSEL,
    componentName: 'PCarousel'
  }
]


export function getComponentNameByComponentTypeEnums(type) {
  let node = ComponentTypeList.find(item => item.key === type)
  return node ? node.componentName : ''
}
